import { api } from "./client";

const BASE = "/modules/gr-invoice-automation";

export const grInvoiceAutomationApi = {
  configStatus: () => api.get(`${BASE}/config-status`).then((r) => r.data),
  suppliers: (params = {}) =>
    api.get(`${BASE}/suppliers`, { params }).then((r) => r.data.suppliers),
  warehouses: () =>
    api.get(`${BASE}/warehouses`).then((r) => r.data.warehouses),

  searchHeaders: (params) =>
    api
      .get(`${BASE}/gr-headers`, {
        params: {
          ...params,
          supplierCodes: (params.supplierCodes || []).join(","),
          branchCodes: (params.branchCodes || []).join(","),
        },
      })
      .then((r) => r.data.headers),

  lines: (docEntries) =>
    api.post(`${BASE}/gr-lines`, { docEntries }).then((r) => r.data.lines),

  generate: (docEntries, excludeFresh) =>
    api
      .post(`${BASE}/generate`, { docEntries, excludeFresh })
      .then((r) => r.data),

  duvoPush: (payload, { sandboxId, startRun = false } = {}) =>
    api
      .post(`${BASE}/duvo-push`, { payload, sandboxId, startRun })
      .then((r) => r.data),

  sandboxFiles: (sandboxId) =>
    api
      .get(`${BASE}/duvo-sandbox/${encodeURIComponent(sandboxId)}/files`)
      .then((r) => r.data.files),

  // ── AP Invoice intake (manual tester) ─────────────────────────────────
  // Path is `/inbound-test/...` (not `/inbound/test/...`) because the
  // `/inbound` prefix is reserved for the API-key-only webhook router.
  testInbound: (kind, body) =>
    api.post(`${BASE}/inbound-test/${kind}`, body).then((r) => r.data),
};
